import * as React from "react";

function SvgCertif(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
      <defs>
        <style>
          {
            ".certif_svg__prefix__cls-1{fill:none}.certif_svg__prefix__cls-6{stroke:none}"
          }
        </style>
      </defs>
      <g
        id="certif_svg__prefix__Grupo_256"
        data-name="Grupo 256"
        transform="translate(-42 -350)"
      >
        <path
          id="certif_svg__prefix__Ret\xE2ngulo_144"
          d="M0 0h20v20H0z"
          className="certif_svg__prefix__cls-1"
          data-name="Ret\xE2ngulo 144"
          transform="translate(42 350)"
        />
        <g
          id="certif_svg__prefix__Grupo_255"
          data-name="Grupo 255"
          transform="translate(0 -20)"
        >
          <g
            id="certif_svg__prefix__Ret\xE2ngulo_179"
            data-name="Ret\xE2ngulo 179"
            transform="translate(43 370)"
            strokeWidth={2}
            stroke="currentColor"
            fill="none"
          >
            <rect
              width={18}
              height={15}
              className="certif_svg__prefix__cls-6"
              rx={3}
            />
            <rect
              width={16}
              height={13}
              x={1}
              y={1}
              className="certif_svg__prefix__cls-1"
              rx={2}
            />
          </g>
          <path
            id="certif_svg__prefix__Uni\xE3o_9"
            d="M-5188-2245a1 1 0 01-1-1 1 1 0 011-1h8a1 1 0 011 1 1 1 0 01-1 1zm0-4a1 1 0 01-1-1 1 1 0 011-1h8a1 1 0 011 1 1 1 0 01-1 1z"
            data-name="Uni\xE3o 9"
            transform="translate(5236 2625.5)"
            fill="currentColor"
          />
          <g
            id="certif_svg__prefix__Grupo_254"
            data-name="Grupo 254"
            transform="translate(0 .4)"
            fill="#fff"
          >
            <g
              id="certif_svg__prefix__Elipse_11"
              data-name="Elipse 11"
              transform="translate(52 381)"
              strokeWidth={1.8}
              stroke="currentColor"
            >
              <circle
                cx={3}
                cy={3}
                r={3}
                className="certif_svg__prefix__cls-6"
              />
              <circle
                cx={3}
                cy={3}
                r={2.1}
                className="certif_svg__prefix__cls-1"
              />
            </g>
            <g id="certif_svg__prefix__Uni\xE3o_8" data-name="Uni\xE3o 8">
              <path
                d="M-5187.634-2267.903h-.001l1-1.732-1 1.732z"
                className="certif_svg__prefix__cls-6"
                transform="translate(5240.134 2656.471)"
              />
              <path
                d="M-5182.634-2266.902c-.345 0-.68-.18-.866-.5l-1.5-2.598 1.732-1 1.5 2.599a1 1 0 01-.866 1.499zm-5 0a.998.998 0 01-.866-1.499l1.5-2.6 1.731 1-1.5 2.599c-.184.32-.52.5-.865.5z"
                transform="translate(5240.134 2656.471)"
                fill="currentColor"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgCertif;

